
import { CiudadService } from './../services/ciudad.service';
import { Component, Input, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { AuthService } from '../services/auth.service';
import ICredencialUsuario from '../models/credencial';
import { ICiudad } from '../models/ciudad';
import { GestionkilometrajeService } from '../services/gestionkilometraje.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IHistoricoUGK } from '../models/hisguk';
import * as saveAs from 'file-saver';
import { IpostGestionKilometraje } from '../models/guardargestionkilometraje';

//interface para los BreadcrumbLink
interface BreadcrumbLink { name: string; href?: string; }

@Component({
  selector: 'app-gestionkilometraje',
  templateUrl: './gestionkilometraje.component.html',
  styleUrls: ['./gestionkilometraje.component.scss']
})
export class GestionkilometrajeComponent {
  @Input() heading: string = '';
  @Input() links: BreadcrumbLink[] = [
    { name: 'Dashboard', href: '/' },
    { name: 'Gestión de Kilometraje' }
  ];

  @ViewChild('dt1') dt!: Table;

  user: ICredencialUsuario = {};
  lstCiudades: ICiudad[] = [];
  selectedCiudad: ICiudad = {
    id: 0,
    nombre: '',
    clave_Estado: '',
    id_ciudad_principal: 0
  };

  // clv_permiso:boolean= false;
  num_economico: string = '';
  kilometraje_nuevo: number = 0;
  id_estatus_unidad: number = 0;
  kilometraje_anterior: number = 0;
  dspOpenHis: boolean = false;
  dspAgregar: boolean = false
  loading: boolean = false;
  fec_gestionKilometraje: string = ''
  fec_inicio: string = ''
  fec_fin: string = ''
   fec_inicioRpt: string = ''
  fec_finRpt: string = ''
  clv_operacion: number = 0;
  lstgestionkilometraje: any;
  dspEditar: boolean = false;
  datos: boolean = false
  lstHistorico: IHistoricoUGK[] = [];


  lstEstatus = [
    { clv_estatus: 1, desc_estatus: 'ACTIVA' },
    { clv_estatus: 3, desc_estatus: 'BAJA DE OPERACION' },
    { clv_estatus: 0, desc_estatus: 'INACTIVA' }
  ]

  lstruta = [
    { id_ruta: 1, Ruta: 'Media Ruta(en curso)' },
    { id_ruta: 2, Ruta: 'Fin de Ruta(patio)' }
  ]

  ngOnInit(): void {
    this.getgestionkilometraje();
    this.cargarListadoCiudades();
    this.inicializarFechasFormateadas();
    const today = new Date();
    this.fec_inicio = today.toISOString().substring(0, 10)
    this.fec_fin = today.toISOString().substring(0, 10)
     this.fec_inicioRpt = today.toISOString().substring(0, 10)
    this.fec_finRpt = today.toISOString().substring(0, 10)
    // this.reactiveform.controls['fec_gestionKilometraje'].setValue(today.toISOString().substring(0, 10))
  }
  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private auth: AuthService,
    private ciudadService: CiudadService,
    private gestionkilometrajeService: GestionkilometrajeService
  ) {
    this.cargarInformacionUsuario();
  }


  reactiveform: FormGroup = new FormGroup({
    idx: new FormControl(0),
    id_unidad_transporte: new FormControl(0),
    num_economico: new FormControl('', [Validators.required]),
    fec_gestionKilometraje: new FormControl('', [Validators.required]),
    kilometraje_anterior: new FormControl(0),
    kilometraje_nuevo: new FormControl(0, [Validators.required]),
    id_ciudad: new FormControl(0),
    desc_ciudad: new FormControl(''),
    clave_configuracionUnidad: new FormControl(0),
    clv_estatus: new FormControl(0),
    desc_estatus: new FormControl(''),
    id_estatus_unidad: new FormControl(0, [Validators.required]),

  })


  agregarNuevo(data: any) {
     const today = new Date().toISOString().substring(0, 10);
    this.reactiveform.controls['fec_gestionKilometraje'].setValue(today)


    this.reactiveform.get('kilometraje_anterior')?.disable();
    this.reactiveform.get('num_economico')?.disable();
   this.clv_operacion !== 3 && this.clv_operacion !== 1
  ? this.reactiveform.get('fec_gestionKilometraje')?.disable()
  : this.reactiveform.get('fec_gestionKilometraje')?.enable();

    this.reactiveform.controls['idx'].setValue(data.idx || 0)
    this.dspAgregar = true;

    this.reactiveform.controls['num_economico'].setValue(data.num_economico)
    this.reactiveform.controls['kilometraje_anterior'].setValue(data.kilometraje_anterior)
    this.reactiveform.controls['id_unidad_transporte'].setValue(data.id_unidad_transporte)
    this.reactiveform.controls['id_ciudad'].setValue(data.id_ciudad)
    this.reactiveform.controls['desc_ciudad'].setValue(data.desc_ciudad)
    this.reactiveform.controls['clave_configuracionUnidad'].setValue(data.clave_configuracionUnidad)
    this.reactiveform.controls['clv_estatus'].setValue(data.clv_estatus)
    this.reactiveform.controls['desc_estatus'].setValue(data.desc_estatus)



  }


  cancelarModal() {
    this.dspAgregar = false;
    this.reactiveform.controls['kilometraje_anterior'].reset();
    this.reactiveform.controls['num_economico'].reset();
    this.reactiveform.controls['kilometraje_nuevo'].reset();
    this.reactiveform.controls['id_estatus_unidad'].reset();
    this.reactiveform.controls['fec_gestionKilometraje'].setValue(new Date().toISOString().substring(0, 10)
    )
  }


  limpiarlist() {
    this.lstHistorico = []
  }

  dspOpenHistorico(data:any) {

    const today = new Date();
    this.fec_hoy = today.toISOString().substring(0, 10)

    this.dspOpenHis = true;
    this.reactiveform.controls['id_unidad_transporte'].setValue(data.id_unidad_transporte)


  }
  cancelarModalHis() {

    this.dspOpenHis = false;
    this.dspEditar = false;
    this.lstHistorico = []
    this.reactiveform.reset();
    const today = new Date();
    this.fec_inicio = today.toISOString().substring(0, 10)
    this.fec_fin = today.toISOString().substring(0, 10)


  }

fec_hoy: string =''

  openModalEditar(data: any) {

  this.reactiveform.controls['fec_gestionKilometraje'].setValue(data.fec_gestionKilometraje)
    this.reactiveform.get('kilometraje_anterior')?.disable();
    this.reactiveform.get('num_economico')?.disable();
     this.clv_operacion !== 3 && this.clv_operacion !== 1 ? this.reactiveform.get('fec_gestionKilometraje')?.disable() : this.reactiveform.get('fec_gestionKilometraje')?.enable();

    this.reactiveform.controls['idx'].setValue(data.idx)
    this.dspEditar = true

    this.reactiveform.controls['id_estatus_unidad'].setValue(data.id_estatus_unidad)
    this.reactiveform.controls['num_economico'].setValue(data.num_economico)
    this.reactiveform.controls['kilometraje_anterior'].setValue(data.kilometraje_anterior)
    this.reactiveform.controls['kilometraje_nuevo'].setValue(data.kilometraje_nuevo)
    this.reactiveform.controls['id_unidad_transporte'].setValue(data.id_unidad_transporte)
    this.reactiveform.controls['id_ciudad'].setValue(data.id_ciudad)
    this.reactiveform.controls['desc_ciudad'].setValue(data.desc_ciudad)
    this.reactiveform.controls['clave_configuracionUnidad'].setValue(data.clave_configuracionUnidad)
    this.reactiveform.controls['clv_estatus'].setValue(data.clv_estatus)
    this.reactiveform.controls['desc_estatus'].setValue(data.desc_estatus)
  }


  cancelarModalEditar() {
    this.dspEditar = false;

  }



  cargarListadoCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
      setTimeout(() => {

      }, 800);
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }


  getgestionkilometraje() {
    this.loading = true;
    this.gestionkilometrajeService.getUnidades(this.user.cod!).subscribe((resp) => {
      this.lstgestionkilometraje = resp;
      this.clv_operacion = resp[0].clv_operacion
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Registros>', detail: 'Contacte al Administrador del Sitio' });
        this.loading = false;
      });
  }

  getHistorico() {
    this.loading_reporte = true;
    this.lstHistorico = [];
    if (!this.fec_inicio || !this.fec_fin) {
      this.messageService.add({
        severity: 'info',
        summary: 'Fechas inválidas',
        detail: 'Por favor, selecciona un rango de fechas válido antes de continuar.'
      });
      this.loading_reporte = false;
      return;
    }
    // this.lstHistorico.length ? this.datos= true : true
    this.gestionkilometrajeService.getHistorico(this.reactiveform.controls['id_unidad_transporte'].value, this.fec_inicio, this.fec_fin).subscribe((resp) => {
      this.lstHistorico = resp
      this.loading_reporte = false;
      if (resp.length <= 0) {
        this.loading_reporte = false;
        this.messageService.add({
          severity: 'info', summary: 'Sin resultados',
          detail: 'No hay datos disponibles para las fechas indicadas. Intenta con otro rango de fechas.'
        })
      }
      setTimeout(() => {

      }, 1000);
    }, (erro) => {
      this.messageService.add({ severity: 'error', summary: 'Error en cargar <Historico>', detail: 'Contacte al Administrador del Sitio' });
      this.loading_reporte = false;
    });
  }

  guardar(id_operacion: number) {

    const ruta = this.lstruta.find(x => x.id_ruta == this.reactiveform.controls['id_estatus_unidad'].value)
    this.loading = true;
    if (this.reactiveform.controls['kilometraje_nuevo'].value < this.reactiveform.controls['kilometraje_anterior'].value) {
      this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Advertencia', detail: 'No se puede capturar un kilometraje menor al ultimo capturado' });
      this.loading = false;
      return
    }

    const payload : IpostGestionKilometraje={
      id_operacion: id_operacion, //editar
      idx: this.reactiveform.controls['idx'].value || 0,
      num_economico: this.reactiveform.controls['num_economico'].value,
      id_estatus_unidad: this.reactiveform.controls['id_estatus_unidad'].value,
      desc_estatus_unidad: ruta?.Ruta,
      kilometraje_anterior: this.reactiveform.controls['kilometraje_anterior'].value,
      kilometraje_nuevo: this.reactiveform.controls['kilometraje_nuevo'].value,
      fec_gestionKilometraje: this.reactiveform.controls['fec_gestionKilometraje'].value,
      id_unidad_transporte: this.reactiveform.controls['id_unidad_transporte'].value,
      id_ciudad: this.reactiveform.controls['id_ciudad'].value,
      clave_configuracionUnidad: this.reactiveform.controls['clave_configuracionUnidad'].value,
      cod_usuario: this.user.cod!,
      clv_estatus: this.reactiveform.controls['clv_estatus'].value,
      desc_estatus: this.reactiveform.controls['desc_estatus'].value,
    }

    this.gestionkilometrajeService.guardarKilometraje(payload).subscribe((resp) => {

      if (resp.clv_estatus == 1) {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: resp.messageDetails });
        this.cancelarModal();
        this.getgestionkilometraje()
        this.cancelarModalEditar()
        id_operacion === 2 ? this.getHistorico() : ''

        this.loading = false;
      }
      if (resp.clv_estatus === -2) {
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Advertencia', detail: resp.messageDetails });
        this.loading = false;
      }
      setTimeout(() => {

      }, 800);
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Error al guardar el registro <Gestión de Kilometraje>', detail: '' });
      this.loading = false;
    }

    )
  }


  inicializarFechasFormateadas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    // this.fecha_dia = dateFormat;
    // this.fecha_del_dia = new Date(dateFormat + 'T00:00:00');
    // //Fecha que no se modifica
    // this.fecha_final_dia = new Date(dateFormat + 'T00:00:00');
    // //Fecha para restar los 3 dias
    // let minus3days = new Date(this.fecha_final_dia);
    // this.fecha_minus3 = new Date(minus3days.setDate(new Date(minus3days).getDate() - 4));

    // //Fecha del dia real, no se mueve
    // this.fecha_dia_real = dateFormat;
  }



  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario ;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
  }

  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }


  loading_reporte: boolean = false;
  desHabilitarBotones: boolean = true;
  lstRpt: any = []
  limpiarFiltrosTabla() {
    this.dt.clear();
  }
  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getRptGestionKilometraje() {
    this.loading_reporte = true;

    this.gestionkilometrajeService.getRptGestionKilometraje(this.reactiveform.controls['id_unidad_transporte'].value, this.fec_inicio, this.fec_fin).subscribe((resp) => {
      this.lstRpt = resp;
      if (this.lstRpt.length == 0 || typeof this.lstRpt === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.lstRpt);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          setTimeout(() => {

          }, 1000);
          this.saveAsExcelFile(excelBuffer, "ReporteGestionKilometraje" + '_del_' + this.fec_inicio + '_al_' + this.fec_fin + '_export-');
        });
      }
      this.loading_reporte = false;

    },
      (error) => {

        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <ReporteGestionKilometraje>', detail: 'Contacte al Administrador del Sitio' });
        this.loading_reporte = false;

      });
  }

  //reporte--------------------
  saveAsExcelFile(buffer: any, fileName: string): void {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;

    let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    // saveAs(data, fileName + EXCEL_EXTENSION);
 saveAs(data, fileName + "_" + dateFormat + EXCEL_EXTENSION);
  }

  dspReportes:boolean= false;

  openDialogReporte(){
  this.dspReportes= true;

  }

  closeDialogReporte(){
 this.dspReportes= false;
   const today = new Date();
  this.fec_inicioRpt = today.toISOString().substring(0, 10)
    this.fec_finRpt = today.toISOString().substring(0, 10)
  }

  generarReporte(){
       this.loading_reporte = true;

    this.gestionkilometrajeService.generarReporte( this.fec_inicioRpt, this.fec_finRpt).subscribe((resp) => {
      this.lstRpt = resp;
      if (this.lstRpt.length == 0 || typeof this.lstRpt === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.lstRpt);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          setTimeout(() => {

          }, 1000);
          this.saveAsExcelFile(excelBuffer, "GestionKilometrajeAlDia" + '_del_' + this.fec_inicioRpt + '_al_' + this.fec_finRpt + '_export-');
        });
      }
      this.loading_reporte = false;

    },
      (error) => {

        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <GestionKilometrajeAlDia>', detail: 'Contacte al Administrador del Sitio' });
        this.loading_reporte = false;

      });
  }
}
